import React from 'react';
import { createIcon } from './create-icon';
import './icon-share.scss';

export const IconShare = createIcon(<div className="icon-share" />);
